<template>
  <b-card no-body class="card mb-0 mt-0 p-3">
    <div
      class="form-group bmd-form-group"
      v-bind:class="{'is-filled': !!model.client_follow_up}"
    >
      <label for="client_follow_up" class="bmd-label-floating">Acompanhar clientes - período padrão (dias)</label>
      <input
        id="client_follow_up"
        type="text"
        class="form-control"
        v-model="model.client_follow_up"
      />
    </div>
  </b-card>
</template>

<script>
export default {
  computed: {
    model: function () {
      return this.$store.state.configurations.model;
    },
  },
};
</script>
